import { gql } from "@apollo/client";

export const UPDATE_DETALLE_LIQUIDACION = gql`
    mutation updateDetalleLiquidacion($inputs: [EditLiquidacionInput!]!) {
        updateDetalleLiquidacion(inputs: $inputs)
    }
`;